import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  WfMdProcessHdrService,
  WfMdProcessHdrContainerModel
} from 'blg-akaun-ts-lib';
import { ReplaySubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import { AppConfig } from '../../visa';

@Component({
  selector: 'app-workflow-process',
  templateUrl: './workflow-process.component.html',
  styleUrls: ['./workflow-process.component.css']
})
export class WorkflowProcessComponent implements OnInit, OnDestroy {

  @Input() process: FormControl;
  @Output() processChange = new EventEmitter<FormControl>();

  private subs = new SubSink();

  private apiVisa = AppConfig.apiVisa;
  filterControl = new FormControl();
  filteredOptions$: ReplaySubject<WfMdProcessHdrContainerModel[]> = new ReplaySubject<WfMdProcessHdrContainerModel[]>(1);
  processList: WfMdProcessHdrContainerModel[];

  constructor( private processService: WfMdProcessHdrService ) {}

  ngOnInit() {
    this.subs.sink = this.processService.get(this.apiVisa).subscribe(
      {next: resolve => {
        this.processList = resolve.data;
        this.filteredOptions$.next(this.processList);
      }});
    // if (this.applet.value) {
    //   this.subs.sink = this.appletService.getByGuid(this.applet.value, this.apiVisa).subscribe( resolved => {
    //     this.branchList = [resolved.data];
    //     this.filteredOptions$.next([resolved.data]);
    //     this.onSelect(resolved.data.bl_fi_mst_branch.guid.toString());
    //   });
    // }
    this.subs.sink = this.filterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({next: resolve => this.filterApplet(resolve)});
  }

  filterApplet(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.processList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.processList.filter(c => c.bl_wf_md_process_hdr.name.toLocaleLowerCase().includes(search));
      this.filteredOptions$.next(filter);
    }

  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
